import type { ReactNode } from 'react';

export const symbol_align_horizontal_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-110v-180H290q-20.83 0-35.42-14.62Q240-319.24 240-340.12q0-20.88 14.58-35.38Q269.17-390 290-390h160v-180H170q-20.83 0-35.42-14.62Q120-599.24 120-620.12q0-20.88 14.58-35.38Q149.17-670 170-670h280v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180h280q20.83 0 35.42 14.62Q840-640.76 840-619.88q0 20.88-14.58 35.38Q810.83-570 790-570H510v180h160q20.83 0 35.42 14.62Q720-360.76 720-339.88q0 20.88-14.58 35.38Q690.83-290 670-290H510v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-97.25 450-110Z"
		/>
	</svg>
);
